import React, { useState } from 'react';

const TERMS_URL = 'https://sharc.fm/terms';
const PRIVACY_URL = 'https://sharc.fm/privacy';

export default function TermsModal({ onAccept }) {
    const [accepting, setAccepting] = useState(false);
    const [error, setError] = useState(null);

    const handleAccept = async () => {
        setAccepting(true);
        setError(null);
        try {
            await onAccept();
        } catch (e) {
            setError('Something went wrong. Please try again.');
            setAccepting(false);
        }
    };

    return (
        <div style={S.overlay}>
            <div style={S.modal}>
                <div style={S.header}>
                    <img
                        src="/sharc_nav_logo.png"
                        alt="SHARC"
                        style={S.logo}
                    />
                    <h2 style={S.title}>Welcome to sharc.fm</h2>
                    <p style={S.subtitle}>
                        Before you continue, please review and accept our updated legal terms.
                    </p>
                </div>

                <div style={S.body}>
                    <div style={S.docLinks}>
                        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={S.docLink}>
                            <span style={S.docIcon}>📄</span>
                            <div>
                                <div style={S.docTitle}>Terms &amp; Conditions</div>
                                <div style={S.docSub}>Rules for using the platform</div>
                            </div>
                            <span style={S.docArrow}>↗</span>
                        </a>
                        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={S.docLink}>
                            <span style={S.docIcon}>🔒</span>
                            <div>
                                <div style={S.docTitle}>Privacy Policy</div>
                                <div style={S.docSub}>How we collect and use your data</div>
                            </div>
                            <span style={S.docArrow}>↗</span>
                        </a>
                    </div>

                    <p style={S.consent}>
                        By clicking <strong>I Agree</strong>, you confirm that you have read and agree to
                        the sharc.fm <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={S.inlineLink}>Terms &amp; Conditions</a> and{' '}
                        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={S.inlineLink}>Privacy Policy</a>.
                    </p>

                    {error && <p style={S.error}>{error}</p>}
                </div>

                <div style={S.footer}>
                    <button
                        onClick={handleAccept}
                        disabled={accepting}
                        style={{
                            ...S.acceptBtn,
                            opacity: accepting ? 0.7 : 1,
                            cursor: accepting ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {accepting ? 'Saving…' : 'I Agree — Continue to sharc.fm'}
                    </button>
                </div>
            </div>
        </div>
    );
}

const S = {
    overlay: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
    },
    modal: {
        backgroundColor: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '480px',
        boxShadow: '0 24px 60px rgba(0,0,0,0.7)',
        overflow: 'hidden',
    },
    header: {
        padding: '32px 32px 24px',
        borderBottom: '1px solid #2a2a2a',
        textAlign: 'center',
    },
    logo: {
        height: '28px',
        width: 'auto',
        marginBottom: '16px',
    },
    title: {
        margin: '0 0 8px',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#e0e0e0',
    },
    subtitle: {
        margin: 0,
        fontSize: '14px',
        color: '#888',
        lineHeight: 1.5,
    },
    body: {
        padding: '24px 32px',
    },
    docLinks: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    docLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '14px 16px',
        backgroundColor: '#252525',
        border: '1px solid #333',
        borderRadius: '8px',
        textDecoration: 'none',
        color: '#e0e0e0',
        transition: 'border-color 0.15s',
    },
    docIcon: {
        fontSize: '20px',
        flexShrink: 0,
    },
    docTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#e0e0e0',
        marginBottom: '2px',
    },
    docSub: {
        fontSize: '12px',
        color: '#777',
    },
    docArrow: {
        marginLeft: 'auto',
        fontSize: '14px',
        color: '#bb86fc',
        flexShrink: 0,
    },
    consent: {
        fontSize: '13px',
        color: '#777',
        lineHeight: 1.6,
        margin: '0',
    },
    inlineLink: {
        color: '#bb86fc',
        textDecoration: 'none',
    },
    error: {
        marginTop: '12px',
        fontSize: '13px',
        color: '#e57373',
    },
    footer: {
        padding: '0 32px 32px',
    },
    acceptBtn: {
        width: '100%',
        padding: '14px',
        backgroundColor: '#bb86fc',
        border: 'none',
        borderRadius: '8px',
        color: '#121212',
        fontSize: '15px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
};
